import React from 'react';
import IconaCondiv21Out from '../../assets/icone/card/IconaCondividiOut2.svg'
import { showToast } from '../toast/ToastNotifier';

const ShareButton = ({ url }) => {
    const shareUrl = () => {
        if (navigator.share) {
            // Usa la condivisione nativa se disponibile (mobile)
            navigator.share({
                title: 'Guarda questa offerta!',
                url: url,
            })
        } else {
            // Fallback per desktop: copia l'URL negli appunti
            navigator.clipboard.writeText(url)
                .then(() => showToast.success('Link copiato negli appunti!'))
                .catch((error) => showToast.error('Error copying link', error));
        }
    };

    return (
        <button onClick={shareUrl} className="bg-white rounded-full p-4">
            <img src={IconaCondiv21Out} alt="Share Icon" className="w-6" />
        </button>
    );
};

export default ShareButton;
